import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersonalState } from '../interfaces/store';


const initialState: PersonalState = {
  name: '',
  description: '',
  email: '',
  phone: '',
  street: '',
  birthday: '',
  birthplace: '',
  license: '',
  nationality: '',
  maritalStatus: '',
  avatar: ''
};

const personalSlice = createSlice({
  name: 'personal',
  initialState,
  reducers: {
    updateField(state, action: PayloadAction<{ name: keyof PersonalState; value: string }>) {
      const { name, value } = action.payload;
      state[name] = value;
    },
  },
});

export const { updateField } = personalSlice.actions;
export default personalSlice.reducer;
